export async function consumeChatStream(body, {onDelta, onSession, onDone}) {
  if (!body) throw new Error('The chat stream is unavailable.');
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let completed = false;
  try {
    while (true) {
      const {done, value} = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, {stream:true});
      let boundary;
      while ((boundary = /\r?\n\r?\n/.exec(buffer))) {
        const frame = buffer.slice(0, boundary.index);
        buffer = buffer.slice(boundary.index + boundary[0].length);
        const data = frame.split(/\r?\n/).filter(line => line.startsWith('data:')).map(line => line.slice(5).trimStart()).join('\n');
        if (!data) continue;
        let payload;
        try { payload = JSON.parse(data); } catch { throw new Error('The chat service returned an invalid response.'); }
        if (payload.error) throw new Error(typeof payload.error === 'string' ? payload.error : 'The chat service is unavailable.');
        if (payload.session_id) onSession?.(payload.session_id);
        if (payload.delta) onDelta?.(payload.delta);
        if (payload.done) {
          completed = true;
          onDone?.();
          return;
        }
      }
    }
    if (!completed) throw new Error('The answer was interrupted. Please try again.');
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}
